import React from 'react';
import { useNotificationPoller } from '../hooks/useNotificationPoller';

interface Notification {
  id: number;
  title: string;
  message: string;
  notification_type: string;
  metadata?: any;
}

interface NotificationPollerProps {
  enabled?: boolean;
  interval?: number;
  onNewNotification?: (notification: Notification) => void;
}

/**
 * Компонент для polling уведомлений
 * Автоматически проверяет новые уведомления через API
 */
export const NotificationPoller: React.FC<NotificationPollerProps> = ({
  enabled = true,
  interval = 60000, // 60 секунд по умолчанию
  onNewNotification
}) => {
  useNotificationPoller({
    enabled,
    interval,
    onNewNotification: (notification) => {
      if (onNewNotification) {
        onNewNotification(notification);
      }
    }
  });

  // Этот компонент не рендерит ничего видимого
  return null;
};

export default NotificationPoller;

